class Model {
  constructor(
    descriptionUse,
    firmwareVersion,
    id,
    name,
    active
  ) {
    this.descriptionUse = descriptionUse
    this.firmwareVersion = firmwareVersion
    this.id = id
    this.name = name
    this.active = active
  }

}

export const modelDefault = () => {
  const model = {
    id: 0,
    name: "",
    firmwareVersion: "",
    descriptionUse: "",
    active: true,
  }
  return model
}

export default Model